module.exports = __webpack_public_path__ + "static/media/investbanner.daae045b.png";